export class Tenant {
  constructor(
    public id: number,
    public uid: string,
    public name: string,
  ) {}
}
